module.exports = __webpack_public_path__ + "static/media/share-extension6p7in.228f9354.png";